import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../store/index';
import { Input, Button } from 'antd'
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { apiAccountLogin, apiGetPage } from '../../request/api'

interface loginInfo {
    loginName?: string;
    email?: string;
    phone?: string;
    password?: string;
    verification?: string;
    account?: string;
    emailError?: string;
    phoneError?: string;
    accountError?: string;
    passwordError?: string;
    verificationError?: string;
    enterAccount?: string;
    enterEmail?: string;
    enterPassword?: string;
    enterPasswordAgain?: string;
    enterVerification?: string;
    enterPhone?: string;
    forget?: string;
    getBack?: string;
    next?: string;
    check1?: string;
    verifyIdentity?: string;
    resetPassword?: string;
    orInfo?: string;
    backLogin?: string;
    seccond?: string;
    changeInfo?: string;
    sendVerification?: string;
    verifyIdentityFor?: string;
    sendIdentifying?: string;
}

interface AcountLoginProps {
    handleViewChange: (newView: string, data?: any) => void;
    data?: any;
}
const AcountLogin: React.FC<AcountLoginProps> = ({ handleViewChange, data }) => {
    const navigate = useNavigate();
    const themeColor = useSelector((state: RootState) => state.themeColor.value);
    const [error, setError] = useState<string | null>(null);
    const [isHovered, setIsHovered] = useState(false);
    const [password, setPassword] = useState('')

    // 直接使用中文翻译，移除从context获取的逻辑
    const [loginInfo] = useState<loginInfo>({
        loginName: "登录",
        email: "邮箱",
        phone: "手机",
        password: "密码",
        verification: "验证码",
        account: "账号",
        emailError: "请输入有效的邮箱地址",
        phoneError: "请输入有效的手机号码",
        accountError: "账号长度至少3位",
        passwordError: "密码不得小于6位",
        verificationError: "请输入验证码",
        enterAccount: "请输入账号",
        enterEmail: "请输入邮箱",
        enterPassword: "请输入密码",
        enterPasswordAgain: "请再次输入密码",
        enterVerification: "请输入验证码",
        enterPhone: "请输入手机号",
        forget: "忘记密码",
        getBack: "找回密码",
        next: "下一步",
        check1: "请检查你的邮箱",
        verifyIdentity: "验证身份",
        resetPassword: "重置密码",
        orInfo: "或",
        backLogin: "返回登录",
        seccond: "秒",
        changeInfo: "修改账号",
        sendVerification: "发送验证码",
        verifyIdentityFor: "验证身份以找回密码",
        sendIdentifying: "发送验证码"
    });

    const backToLoginPage = () => {
        handleViewChange('mainLogin', data.account || data.acount)
    }

    const changePassword = (e: React.ChangeEvent<HTMLInputElement>) => {
        const pass = e.target.value
        setPassword(pass)
        setError(null) // 清除之前的错误提示
    }

    const loginIn = () => {
        // 提交时的验证逻辑
        if (password.length < 6) {
            setError(loginInfo.passwordError || '密码不得小于6位');
            return;
        }

        const account = data.account || data.acount;
        if (!account) {
            setError('账号信息不存在');
            return;
        }

        apiAccountLogin({
            accountName: account,
            password: password,
        }, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(res => {
            const token = res.data.data.token;
            const accountName = res.data.data.accountName;
            const headImg = res.data.data.headImg;
            localStorage.setItem('userToken', token);
            localStorage.setItem('userName', res.data.data.name);
            localStorage.setItem('userId', res.data.data.accountId);
            localStorage.setItem('id', res.data.data.id);
            localStorage.setItem('userPhone', res.data.data.phone);
            localStorage.setItem('userEmail', res.data.data.email);
            localStorage.setItem('accountName', accountName);
            localStorage.setItem('headImg', headImg);
            console.log(localStorage.getItem('userToken'))
            navigate('/mine')
            window.location.reload();
        }).catch(err => {
            console.error('登录失败:', err);
            setError('登录失败，请检查账号和密码');
        });
    };

    const toAcountVerification = () => {
        handleViewChange('loadAccount', data.account || data.acount)
    }

    return (
        <div>
            <div className='login-header'>{loginInfo.loginName}</div>
            <div className='login-body'>
                <span>{data.account || data.acount || '未获取到账号'}</span>
                <span
                    onClick={backToLoginPage}
                    className='cursur'
                    style={{
                        color: themeColor,
                        cursor: 'pointer',
                        marginLeft: '10px'
                    }}
                >
                    {loginInfo.changeInfo}
                </span>
            </div>
            <div className='login-body_header'>{loginInfo.password}</div>
            <Input.Password
                status={error ? 'error' : ''}
                placeholder={loginInfo.enterPassword}
                value={password}
                onChange={changePassword}
                onPressEnter={loginIn} // 添加回车键登录
            />
            {error && (
                <div style={{
                    color: '#e60d0d',
                    marginTop: '2px',
                    fontSize: '12px',
                    minHeight: '20px'
                }}>
                    {error}
                </div>
            )}
            <Button
                type="primary"
                onClick={loginIn}
                style={{ marginTop: '24px' }}
            >
                {loginInfo.loginName}
            </Button>
            <div
                className='login-bottom'
                style={{
                    color: isHovered ? themeColor : "#666",
                    marginTop: '20px',
                    textAlign: 'center',
                    fontSize: '14px',
                    cursor: 'pointer',
                    transition: 'color 0.3s'
                }}
                onClick={toAcountVerification}
                onMouseEnter={() => { setIsHovered(true) }}
                onMouseLeave={() => { setIsHovered(false) }}
            >
                {/* {loginInfo.forget} */}
            </div>

        </div>
    )
};

export default AcountLogin;